import { GetAgencyProfileResponse, GetUserProfileResponse, ProfileState } from "Application/models";
import { ProfileService } from "Application/service";
import { create } from "zustand";

export const useProfileStore = create<ProfileState>((set) => ({
  isLoading: false,
  isError: false,
  error: null,
  agencyProfileData: null,
  userProfileData: null,

  getAgencyProfile: async (agencyId: number) => {
    set({ isLoading: true });

    try {
      const response: GetAgencyProfileResponse = await ProfileService.getAgencyProfile(agencyId);

      set({isError: false, error: null, agencyProfileData: response });

    } catch (error) {
        set({ error: 'Failed to get agency profile', isError: true });
        throw error;
    } finally {
      set({ isLoading: false });
    }
  },

  getUserProfile: async (userId: number) => {
    set({ isLoading: true });

    try {
      const response: GetUserProfileResponse = await ProfileService.getUserProfile(userId);

      set({isError: false, error: null, userProfileData: response})

    } catch (error) {
      set({ error: 'Failed to get user profile', isError: true });
      throw error;
    } finally {
      set({ isLoading: false });
    }
  }

}));